import React from "react";
import Contact from "../UI/Contact";
import { MdWifiCalling2 } from "react-icons/md";
import { IoMailUnreadOutline } from "react-icons/io5";
import { FaMapPin } from "react-icons/fa6";

const ContactUs = () => {
  return (
    <div className="max-w-screen-2xl mx-auto px-4 py-12">
      {/* Page Heading */}
      {/* <div className="text-center  bg-[#068b07] p-6 h-[300px]">
        <h1 className="text-3xl mt-20 font-bold text-white">Get in Touch</h1>
        <p className="text-gray-200 mt-2">
          We’d love to hear from you! Whether you have a question, need a quote, or want to discuss a project, our team is ready to help.
        </p>
      </div> */}
      <div className=" mb-8   p-8 ">
        <h2 className="text-2xl font-semibold text-black">Contact Information</h2>
        <p className="text-gray-800 mt-2">
          You can also reach us via phone, email, or visit our office.
        </p>

        <div className="grid md:grid-cols-3 gap-6 mt-6 text-gray-600">
          {/* Phone */}
          <div className="flex items-center">
            <span className="text-[#068b07] text-xl font-bold"><MdWifiCalling2/></span>
            <p className="ml-3">
              <strong>Phone:</strong> <br />  
              +91 9791692008
            </p>
          </div>

          {/* Email */}
          <div className="flex items-center">
            <span className="text-[#068b07] text-xl font-bold"><IoMailUnreadOutline  size={26}/></span>
            <p className="ml-3">
              <strong>Email:</strong> <br />
              greenarcade.official@gmail.com
            </p>
          </div>

          {/* Location */}
          <div className="flex items-center">
            <span className="text-[#068b07] text-xl font-bold"><FaMapPin  size={26}/></span>  
            <p className="ml-3">
              <strong>Address:</strong> <br />
              2nd Floor, Najam Centre, Virudampet,  <br />
Vellore - 632006, Tamil Nadu, India
            </p>
          </div>
        </div>
      </div>

      {/* Contact Form */}
      <Contact />

      {/* Additional Contact Details */}
      

      {/* Support Availability */}
      <div className="text-center mt-8">
        <p className="text-gray-600">
          <strong>Working Hours:</strong> Monday - Sunday, 9:00 AM - 6:00 PM
        </p>
        <p className="text-gray-600 mt-2">We usually respond within <span className="text-[#068b07]">24 hours</span>.</p>
      </div>

      {/* Optional: Map (If Required) */}
      {/* <div className="mt-8">
        <iframe
          title="Our Location"
          src="https://maps.google.com/..."
          className="w-full h-64 rounded-lg"
          loading="lazy"
        ></iframe>
      </div> */}
    </div>
  );
};

export default ContactUs;
